import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import moment from "moment";
import { MdOutlineMoreHoriz } from "react-icons/md";
import { useState } from "react";
import { setSelectedBlockedUser } from "../../features/blockedUsers/blockedUserSlice";
import { showModal } from "../../features/modal/modalSlice";


const Container = styled.div`
  width: 100%;
  margin-block: 5px;
  background-color: ${({ theme }) => theme.secondaryBgColor};
  .container {
    width: 100%;
    .content {
      width: 100% !important;
      padding: 15px 10px;
      border-radius: 10px;
      margin: 10px 0px 0px 0px !important;
      position: relative;
      background-color: var(--color-light);
      color: ${({ theme }) => theme.mainTextColor} !important;
      height: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      .more{
        position: absolute;
        right: 10px;
        cursor: pointer;
        font-size: 20px;
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
     
      .row {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
        gap: 15px;
        text-align: center;
        background-color: transparent;
        .col {
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-md);
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          .plate{
            margin-block: 5px;
          }
          span {
            font-size: 20px;
          }
          
        }
      }
    }
  }
`;

const EngellenenAraclarContainer = ({ data }) => {
  const { theme } = useSelector((state) => state.layout);
  const dispatch = useDispatch();

  return (
    <Container theme={theme}>
      <div className="container">
        <div className="content">
          <div className="row">
            <div className="col">
              {data?.phoneNumber}
            </div>
            <div className="col">
              {data?.fullNameTitle}
            </div>
            <div className="col">
              {data.nationalId}
            </div>
            <div className="col">
              {data?.plateNumbers?.map((item) => (
                <div className="plate">{item.plate}</div>
              ))}
            </div>
            <div className="col">
              {data.description}
            </div>
            <div className="col">
                {moment(data.createdAt).format('L') === "Invalid date" ? "-" : moment(data.createdAt).format('L')}
            </div>
          </div>

          <div onClick={()=> {dispatch(showModal("firmaKaraListeOption")); dispatch(setSelectedBlockedUser(data))}} className="more"><MdOutlineMoreHoriz/></div>
        </div>
      </div>
    </Container>
  );
};

export default EngellenenAraclarContainer;
